import { LanguagesEnum } from '../../config/languages';

const Configuration = {
  backgroundImage: require('../../assets/images/backgrounds/dark-material-bg.jpg'),
};

export const Translations = {
  recover_title: {
    [LanguagesEnum.English]: 'Recover your password',
    [LanguagesEnum.Greek]: 'Επαναφορά κωδικού',
  },
  form_field_email: {
    [LanguagesEnum.English]: 'Username',
    [LanguagesEnum.Greek]: 'Username',
  },
  form_button_recover: {
    [LanguagesEnum.English]: 'Recover',
    [LanguagesEnum.Greek]: 'Επαναφορά',
  },
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  back_to_login: {
    [LanguagesEnum.English]: 'Back to login',
    [LanguagesEnum.Greek]: 'Επιστροφή στο Login',
  },
};

export default Configuration;
